function SupportIcon({ className }) {
  return (
    <svg
      className="h-full w-full"
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.087 78.9546C78.9574 78.9546 88.5802 69.3739 88.5802 57.5554C88.5802 45.737 78.9574 36.1562 67.087 36.1562C55.2166 36.1562 45.5938 45.737 45.5938 57.5554C45.5938 69.3739 55.2166 78.9546 67.087 78.9546Z"
        fill="#A1C323"
        fill-opacity="0.4"
      />
      <path
        d="M25.6367 62.334L39.4538 54.6914H54.8061C54.8061 54.6914 60.947 54.6914 60.947 59.2769C60.947 63.8625 56.3413 63.8625 56.3413 63.8625H47.1299"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M64.0771 63.864L68.6828 60.9843L76.299 56.2214C76.299 56.2214 83.0464 52.3482 85.5104 56.2214C87.9745 60.0947 82.4998 63.864 82.4998 63.864C82.4998 63.864 72.1186 70.3908 67.0876 73.0351C62.482 75.3279 54.8058 74.5636 54.8058 74.5636C52.503 74.5636 36.4429 73.0351 36.4429 73.0351L31.7773 74.5636"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="27.1711"
        cy="77.6202"
        rx="0.921138"
        ry="0.917107"
        fill="#2F6132"
      />
      <path
        d="M28.7078 69.9781L22.5669 57.75L13.3555 62.3355L24.1021 83.7347L33.3135 79.1492L30.243 73.0351"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M58.1113 50.1049C58.1113 50.1049 73.2225 45.8067 73.2225 24.3127C60.2698 24.3127 58.1113 15.7148 58.1113 15.7148C58.1113 15.7148 55.9527 24.3127 43 24.3127C43 43.6561 58.1113 50.1049 58.1113 50.1049Z"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M51.6367 32.9076L55.9538 37.2073L64.5894 28.6094"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default SupportIcon
